module.exports = __webpack_public_path__ + "media/images/common/h3_ranking-d562400d4e20c96533d034a383685f10.png";